import styled from "styled-components";
import { Grid, FormControl, Select } from "@material-ui/core";

export const styles = {
  option: (base: any) => ({
    ...base,
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "1rem",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "1rem",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    marginRight: "25px",
  }),
  control: (base: any) => ({
    ...base,
    cursor: "text",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.54)",
    borderRadius: 0,
    outline: "none !important",
    marginRight: 0,
    boxShadow: "none",
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    marginRight: 0,
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    width: 0,
  }),
  menu: (base: any) => ({
    ...base,
  }),
  menuList: (base: any) => ({
    ...base,
  }),
};

export const STSelect = styled(Select).attrs({
  classes: {
    root: "root",
    selectMenu: "selectMenu",
  },
})`
  && {
    .root {
      display: flex;
      align-items: center;
    }

    .root > .selectMenu {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    },
  }
`;

export const STIconWrapper = styled.div`
  padding-right: 5px;
`;

export const STIconGrid = styled(Grid)`
  && {
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 5px;
  }
`;
export const STFormControl = styled(FormControl)`
  && {
    margin-top: 10px;
    width: 100%;
  }
`;
